import React, { useState } from "react";

import Copy from "../../svg/Copy";
import Check from "../../svg/Check";

// Text with a copy button that appears when the text is hovered
const CopyText = ({ text, className = "" }) => {
  const [copied, setCopied] = useState(false);

  if (!text) return null;

  const doCopy = () => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      })
      .catch(() => {});
  };

  return (
    <span className={`group inline-flex items-center gap-1 ${className}`}>
      <span>{text}</span>
      <button
        type="button"
        aria-label={`Copy ${text}`}
        title={copied ? "Copied" : "Copy"}
        onClick={doCopy}
        className={`copy-button shrink-0 rounded p-0.5 hover:bg-slate-200 focus:opacity-100 group-hover:opacity-100 ${
          copied ? "opacity-100 text-green-700" : "opacity-0 text-gray-500"
        }`}
      >
        {copied ? <Check size={14} /> : <Copy size={14} />}
      </button>
    </span>
  );
};

export default CopyText;
